import { SuccessModalTypes } from '../types';

export interface HandraiserConfig {
  title: string;
  titleFr?: string;
  campaignId: string;
  derivativeCode?: string[] | null;
  successModalConfig: SuccessModalTypes;
  modelSelect?: string[] | null;
  successModalConfigFr?: SuccessModalTypes;
}

const HANDRAISER_SUCCESSFUL_MESSAGE =
  'Thank you for subscribing! You will receive a confirmation email shortly.';

const HANDRAISER_SUCCESSFUL_MESSAGE_FR =
  'Nous vous remercions de votre inscription. Vous recevrez une confirmation par courriel sous peu.';

export const HANDRAISER_CONFIG_US: Record<string, HandraiserConfig> = {
  audif1: {
    title: 'Audi F1',
    campaignId: 'AUUS_IB_DC_25_AUDIF1C_HR',
    derivativeCode: ['AUA000_AUA000'],
    successModalConfig: {
      successCustomHeading: null,
      successCustomBody:
        'Thank you for your interest in Audi F1, you will be the first to know about upcoming Audi F1 details.',
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
  },
  allnewa6: {
    title: 'All-new A6 Sedan',
    campaignId: 'AUUS_IB_DC_25_ALLNEA6_HR',
    derivativeCode: ['AUA604_AUA604'],
    successModalConfig: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
  },
  seasonofaudi: {
    title: 'Season of Audi',
    campaignId: 'AUUS_IB_DC_23_SOADCRM_HR',
    modelSelect: [
      'AUQ310_AUQ310',
      'AUQ510_AUQ510',
      'AUQ701_AUQ701',
      'AUA510_AUA503',
      'AUQ701_AUQ701',
      'AUA510_AUA503',
      'AUA604_AUA604',
      'AUA000_AUA000',
    ],
    successModalConfig: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
  },
  evupdates: {
    title: 'EV Model Updates',
    campaignId: 'AUUS_IB_DC_22_EVIMTCQ_HR',
    modelSelect: [
      'AUQ401_AUQ401',
      'AUQ401_AUQ402',
      'AUQ601_AUQ601',
      'ASQ601_ASQ601',
      'AUQ601_AUQ6SB',
      'ASQ601_ASQ6SB',
      'AUA601_AUA611',
      'AUS601_AUS611',
      'AUEGT1_AUEGTS',
      'AUEGT1_AUEGTR',
      'AUA000_AUA000',
    ],
    successModalConfig: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
  },
  signup: {
    title: 'Sign Up For Updates',
    campaignId: 'AUUS_IB_DC_00_HNDR_RG',
    modelSelect: [
      'AUA000_AUA000',
      'AUA510_AUA503',
      'AUS510_AUS503',
      'AUQ310_AUQ310',
      'AUQ510_AUQ510',
      'AUQ510_AUQ540',
      'AUSQ10_AUSQ10',
      'AUSQ10_AUSQSB',
      'AUQ701_AUQ701',
      'AUSQ71_AUSQ71',
      'AUQ801_AUQ801',
      'AUSQ81_AUSQ81',
      'AURQ81_AURQ81',
      'AUA301_AUA302',
      'AUS301_AUS301',
      'AUR301_AUR301',
      'AUA604_AUA604',
      'AUA801_AUA800',
      'AUS801_AUS801',
      'AUQ401_AUQ401',
      'AUQ401_AUQ402',
      'AUQ601_AUQ601',
      'ASQ601_ASQ601',
      'AUQ601_AUQ6SB',
      'ASQ601_ASQ6SB',
      'AUA601_AUA611',
      'AUS601_AUS611',
      'AUEGT1_AUEGTS',
      'AUEGT1_AUEGTR',
    ],
    successModalConfig: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
  },
  allnewq3: {
    title: 'All-new Q3',
    campaignId: 'AUUS_IB_DC_25_ALLNEQ3_HR',
    derivativeCode: ['AUQ310_AUQ310'],
    successModalConfig: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
  },
  etrongtfam: {
    title: 'e-tron GT Family',
    campaignId: 'AUUS_IB_DC_23_ETRGTSR_HR',
    modelSelect: ['AUEGT1_AUEGTS', 'AUEGT1_AUEGTR'],
    successModalConfig: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
  },
  q6etronfam: {
    title: 'Q6 e-tron Family',
    campaignId: 'AUUS_IB_DC_24_Q6ETRON_HR',
    modelSelect: ['AUQ601_AUQ601', 'ASQ601_ASQ601', 'AUQ601_AUQ6SB', 'ASQ601_ASQ6SB'],
    successModalConfig: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
  },
  a6etronfam: {
    title: 'A6 Sportback e-tron Family',
    campaignId: 'AUUS_IB_DC_25_A6SBETR_HR',
    modelSelect: ['AUA601_AUA611', 'AUS601_AUS611'],
    successModalConfig: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
  },
};

export const HANDRAISER_CONFIG_CA: Record<string, HandraiserConfig> = {
  audif1: {
    title: 'Audi F1',
    titleFr: 'Audi F1',
    campaignId: 'AUCA_IB_DC_25_AUDIF1C_HR',
    derivativeCode: ['AUA000_AUA000'],
    successModalConfig: {
      successCustomHeading: null,
      successCustomBody:
        'Thank you for your interest in Audi F1, you will be the first to know about upcoming Audi F1 details.',
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
    successModalConfigFr: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE_FR,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
  },
  stayinformed: {
    title: 'Stay Informed',
    titleFr: 'Restez informé',
    campaignId: 'AUCA_IB_DC_19_eNEWSLT_HR',
    modelSelect: [
      'AUQ310_AUQ310',
      'AUQ510_AUQ510',
      'AUQ510_AUQ540',
      'AUSQ10_AUSQ10',
      'AUSQ10_AUSQSB',
      'AUQ701_AUQ701',
      'AUSQ71_AUSQ71',
      'AUQ801_AUQ801',
      'AUSQ81_AUSQ81',
      'AURQ81_AURQ81',
      'AUA301_AUA302',
      'AUS301_AUS301',
      'AUR301_AUR301',
      'AUA510_AUA503',
      'AUS510_AUS503',
      'AUA604_AUA604',
      'AUA801_AUA800',
      'AUS801_AUS801',
      'AUQ401_AUQ401',
      'AUQ401_AUQ402',
      'AUQ601_AUQ601',
      'ASQ601_ASQ601',
      'AUQ601_AUQ6SB',
      'ASQ601_ASQ6SB',
      'AUA601_AUA610',
      'AUS601_AUS612',
      'AUEGT1_AUEGTS',
      'AUEGT1_AUEGTR',
      'AUA000_AUA000',
    ],
    successModalConfig: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
    successModalConfigFr: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE_FR,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
  },
  confirm: {
    title: 'Confirm Subscription',
    titleFr: 'Confirmer L’abonnement',
    campaignId: 'AUCA_IB_DC_23_CNSNTRW_HR',
    derivativeCode: ['AUA000_AUA000'],
    successModalConfig: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
    successModalConfigFr: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE_FR,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
  },
  allnewq3: {
    title: 'All-new Q3',
    titleFr: 'Tout-nouveau Q3',
    campaignId: 'AUCA_IB_DC_25_ALLNEQ3_HR',
    derivativeCode: ['AUQ310_AUQ310'],
    successModalConfig: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
    successModalConfigFr: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE_FR,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
  },
  allnewa6: {
    title: 'All-new A6',
    titleFr: 'Tout-nouveau A6',
    campaignId: 'AUCA_IB_DC_25_ALLNEA6_HR',
    derivativeCode: ['AUAQ02_AUAQ02'],
    successModalConfig: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
    successModalConfigFr: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE_FR,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
  },
  rsetrongt: {
    title: 'RS e-tron GT',
    titleFr: 'RS e-tron GT',
    campaignId: 'AUCA_IB_DC_24_RSETRON_HR',
    derivativeCode: ['AUEGT1_AUEGTR'],
    successModalConfig: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
    successModalConfigFr: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE_FR,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
  },
  setrongt: {
    title: 'S e-tron GT',
    titleFr: 'S e-tron GT',
    campaignId: 'AUCA_IB_DC_25_ETROGTS_HR',
    derivativeCode: ['AUEGT1_AUEGTS'],
    successModalConfig: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
    successModalConfigFr: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE_FR,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
  },
  rsq8: {
    title: 'RS Q8',
    titleFr: 'RS Q8',
    campaignId: 'AUCA_IB_DC_24_RSQ8PI_HR',
    derivativeCode: ['AURQ81_AURQ81'],
    successModalConfig: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
    successModalConfigFr: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE_FR,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
  },
  a6etronfam: {
    title: 'A6 e-tron Family',
    titleFr: 'Famille A6 e-tron',
    campaignId: 'AUCA_IB_DC_24_A6ETRON_HR',
    modelSelect: ['AUA601_AUA611', 'AUS601_AUS611'],
    successModalConfig: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
    successModalConfigFr: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE_FR,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
  },
  rs3: {
    title: 'RS 3',
    titleFr: 'RS 3',
    campaignId: 'AUCA_IB_DC_24_RS3_HR',
    derivativeCode: ['AUR301_AUR301'],
    successModalConfig: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
    successModalConfigFr: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE_FR,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
  },
  q6sbetron: {
    title: 'Q6 Sportback e-tron',
    titleFr: 'Q6 Sportback e-tron',
    campaignId: 'AUCA_IB_DC_25_Q6SBETN_HR',
    derivativeCode: ['AUQ601_AUQ6SB'],
    successModalConfig: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
    successModalConfigFr: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE_FR,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
  },
  sq6sbetron: {
    title: 'SQ6 Sportback e-tron',
    titleFr: 'SQ6 Sportback e-tron',
    campaignId: 'AUCA_IB_DC_25_SQ6SBET_HR',
    derivativeCode: ['ASQ601_ASQ6SB'],
    successModalConfig: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
    successModalConfigFr: {
      successCustomHeading: null,
      successCustomBody: HANDRAISER_SUCCESSFUL_MESSAGE_FR,
      successCustomCtaVerbiage: null,
      successCustomCtaUrl: null,
    },
  },
};
